<template>
  <v-dialog
    v-model="dialogEdit"
    max-width="500px"
  >
   <v-card>
     <v-card-title class="title-card">
       <span class="text-h5">{{ formTitle }}</span>
     </v-card-title>

     <v-card-text>
       <v-container>
         <v-form
            ref="form"
            v-model="valid"
          >
          <v-row>
            <v-col
              class="d-flex"
              cols="12"
              sm="12"
              md="12"
            >
              <v-autocomplete
                v-if="obj.pessoa"
                v-model="obj.pessoa.id"
                :items="getPessoas"
                :item-text="'nome'"
                :item-value="'id'"
                outlined
                label="Pessoas"
              ></v-autocomplete>
            </v-col>
            <!--<v-col
              class="d-flex"
              cols="12"
              sm="12"
              md="12"
            >
              <v-autocomplete
                v-model="obj.categoria.id"
                :items="getCategorias"
                :item-text="'nome'"
                :item-value="'id'"
                outlined
                label="Categoria"
              ></v-autocomplete>
            </v-col>-->
            <v-col
              class="d-flex"
              cols="12"
              sm="12"
              md="12"
            >
              <v-autocomplete
                v-model="obj.empresa.id"
                :items="getEmpresas"
                :item-text="'nome'"
                :item-value="'id'"
                outlined
                label="Empresas"
              ></v-autocomplete>
            </v-col>
            <v-col
              class="d-flex"
              cols="12"
              sm="12"
              md="12"
            >
              <v-autocomplete
                v-if="obj.obra"
                v-model="obj.obra.id"
                :items="getObras"
                :item-text="'nome'"
                :item-value="'id'"
                outlined
                label="Unidades"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.nfe"
                label="NFE"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.data_emissao"
                v-mask="'##/##/####'"
                required
                :rules="nameRules"
                label="Data de Emissão"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.data_saida"
                v-mask="'##/##/####'"
                required
                :rules="nameRules"
                label="Data de pagamento"
                outlined
              ></v-text-field>
            </v-col>
            <!--<v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.data_recibo"
                v-mask="'##/##/####'"
                label="Data do recibo"
                outlined
              ></v-text-field>
            </v-col>-->
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.valor"
                required
                :rules="nameRules"
                label="Valor"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              class="d-flex"
              cols="12"
              sm="12"
              md="12"
            >
            <v-text-field
                v-model="obj.pessoaManual"
                required
                label="Descrição manual"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="obj.link_google_drive"
                label="Link GOOGLE DRIVE - NOTA"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="obj.link_google_drive_2"
                label="Link GOOGLE DRIVE - NOTA - 2"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="obj.link_google_drive_3"
                label="Link GOOGLE DRIVE - NOTA - 3"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="obj.link_google_drive_comprovante"
                label="Link GOOGLE DRIVE - COMPROVANTE"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="obj.link_google_drive_comprovante_2"
                label="Link GOOGLE DRIVE - COMPROVANTE - 2"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="obj.link_google_drive_comprovante_3"
                label="Link GOOGLE DRIVE - COMPROVANTE - 3"
                outlined
              ></v-text-field>
            </v-col>

            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive">
              <a :href="obj.link_google_drive" target="_blank">Arquivo - GOOGLE DRIVE - NOTA</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-else>
              <span>Documento não cadastrado -  NOTA</span>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive_2">
              <<a :href="obj.link_google_drive_2" target="_blank">>Arquivo - GOOGLE DRIVE - NOTA - 2</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-else>
              <span>ocumento não cadastrado -  NOTA - 2</span>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive_3">
              <a :href="obj.link_google_drive_3" target="_blank">Arquivo - GOOGLE DRIVE - NOTA - 3</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-else>
              <span>ocumento não cadastrado -  NOTA - 3</span>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive_comprovante">
              <a :href="obj.link_google_drive_comprovante" target="_blank">Arquivo - GOOGLE DRIVE - COMPROVANTE</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-else>
              <span>Documento não cadastrado -  Comprovante</span>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive_comprovante_2">
              <a :href="obj.link_google_drive_comprovante_2" target="_blank">Arquivo - GOOGLE DRIVE - COMPROVANTE - 2</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-else>
              <span>Documento não cadastrado -  Comprovante - 2</span>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive_comprovante_3">
              <a :href="obj.link_google_drive_comprovante_3" target="_blank">Arquivo - GOOGLE DRIVE - COMPROVANTE - 3</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-else>
              <span>Documento não cadastrado -  Comprovante - 3</span>
            </v-col>
          </v-row>
        </v-form>
       </v-container>
     </v-card-text>

     <v-card-actions>
       <v-spacer></v-spacer>
       <v-btn
         color="primary"
         text
         @click="closeEditItem"
       >
         Cancelar
       </v-btn>
       <v-btn
         dark
         color="primary"
         @click="save"
       >
         Salvar
       </v-btn>
     </v-card-actions>
   </v-card>
 </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  props:{
    dialogEdit: Boolean,
    objValue: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      dialogEditTEste: true,
      valid:false,
      formTitle:'Editar',
      nameRules: [
          v => !!v || 'Campo requirido',
      ],
      dialog: false,
      obj: {
        active: true,
        empresa: {
          id: null
        },
        obra: {
          id: null
        },
        nfe: null,
        pessoa: {
          id: null
        },
        /*categoria: {
          id: null
        },*/
        data_saida:'',
        //data_recibo:'',
        valor:'',
      },
    }
  },
  /* eslint-disable */
  watch: {
    objValue(objValue){
      this.obj = {
        ...objValue,
        pessoa : {
          id: null,
          ...objValue.pessoa,
        },
        empresa : {
          id: null,
          ...objValue.empresa,
        },
        /*categoria : {
          id: null,
          ...objValue.categoria,
        },*/
        obra : {
          id: null,
          ...objValue.obra,
        }
      }
    }
  },
  computed: {
    ...mapGetters('empresa', {getEmpresas:'getList'}),
    ...mapGetters('pessoa', {getPessoas:'getList'}),
    ...mapGetters('obra', {getObras:'getList'}),
    //...mapGetters('categoria', {getCategorias:'getList'}),
  },
  methods: {
    ...mapActions('saida', ['updateSaida']),
  async save() {
      this.$refs.form.validate()
      /* eslint-disable no-console */
      if (this.valid) {
        try {
          //const categoria = this.getCategorias.find((item) => item.id === this.obj.categoria.id) ? this.getCategorias.find((item) => item.id === this.obj.categoria.id) : null
          const obra = this.getObras.find((item) => item.id === this.obj.obra.id) ? this.getObras.find((item) => item.id === this.obj.obra.id) : null
          await this.updateSaida({
            ...this.obj,
            active: true,
            empresa:{
              ...this.getEmpresas.find((item) => item.id === this.obj.empresa.id)
            },
            obra,
            //categoria: categoria ? categoria : {},
            pessoa: {
              ...this.getPessoas.find((item) => item.id === this.obj.pessoa.id)
            }
          })
        } catch (error) {
            console.error(error);
        } finally {
            this.closeEditItem();
        }
      }
    },
  reset () {
    this.$refs.form.reset()
  },
  closeEditItem () {
    this.$emit('closeEditItem')
  },
}
}
</script>
